/* WEELZ - on-device image report v4. Dormant unless ?weelzdiag=1.

   Distinguishes real failures from normal lazy-loading. An image more
   than 500px outside the viewport with naturalWidth 0 is NOT blank -
   it simply has not loaded yet, by design. */
(function () {
  'use strict';
  if (location.search.indexOf('weelzdiag') === -1) return;

  var NEAR = 500;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  function fname(u) {
    if (!u) return '(none)';
    if (u.indexOf('data:') === 0) return '(data URI)';
    var q = u.split('?')[0];
    return q.substring(q.lastIndexOf('/') + 1).slice(-34);
  }

  function distance(r, vh) {
    if (r.bottom < 0) return Math.round(r.bottom);           // above viewport (negative)
    if (r.top > vh) return Math.round(r.top - vh);           // below viewport (positive)
    return 0;                                                // intersecting
  }

  function scan() {
    var vh = window.innerHeight;
    var imgs = [].slice.call(document.querySelectorAll('img'));
    var stats = { total: imgs.length, visible: 0, visibleOk: 0, visibleBlank: 0, realError: 0, nearPending: 0, offNotLoaded: 0, offDecoded: 0 };
    var blanks = [];

    imgs.forEach(function (img, idx) {
      var r = img.getBoundingClientRect();
      var d = distance(r, vh);
      var onScreen = d === 0 && r.width > 0 && r.height > 0;
      var loaded = img.naturalWidth > 0;
      var errored = !!img.getAttribute('data-weelz-retried');

      if (errored) stats.realError++;

      if (onScreen) {
        stats.visible++;
        if (loaded) { stats.visibleOk++; return; }
        if (!img.complete) { stats.nearPending++; return; }
        stats.visibleBlank++;

        var cs = getComputedStyle(img);
        var parent = img.parentElement;
        blanks.push(
          '#' + idx + ' ' + esc(fname(img.currentSrc || img.src)) +
          '<br>currentSrc: ' + esc(fname(img.currentSrc)) + ' | src: ' + esc(fname(img.getAttribute('src'))) +
          '<br>' + (img.getAttribute('srcset') ? 'srcset' : 'NO-srcset') +
          ' | sizes ' + esc((img.getAttribute('sizes') || '-').slice(0, 30)) +
          ' | loading ' + (img.getAttribute('loading') || 'eager') +
          '<br>complete ' + img.complete + ' | natural ' + img.naturalWidth + 'x' + img.naturalHeight +
          ' | box ' + Math.round(r.width) + 'x' + Math.round(r.height) +
          ' | dist ' + d + 'px' +
          '<br>display ' + cs.display + ' | visibility ' + cs.visibility + ' | opacity ' + cs.opacity +
          ' | c-v ' + (cs.contentVisibility || 'n/a') +
          ' | parentW ' + (parent ? Math.round(parent.getBoundingClientRect().width) : '?') +
          ' | err ' + (errored ? 'YES' : 'no')
        );
        return;
      }

      // Off-screen
      var near = Math.abs(d) <= NEAR;
      if (loaded) { stats.offDecoded++; return; }
      if (near && !img.complete) { stats.nearPending++; return; }
      stats.offNotLoaded++;
    });

    return { stats: stats, blanks: blanks };
  }

  function show() {
    var d = scan();
    var rows = [
      ['UA', navigator.userAgent.slice(0, 58)],
      ['Total IMG', d.stats.total],
      ['Visible IMG', d.stats.visible],
      ['VISIBLE OK', d.stats.visibleOk],
      ['VISIBLE BLANK', d.stats.visibleBlank],
      ['REAL ERROR (retried)', d.stats.realError],
      ['NEAR VIEWPORT PENDING', d.stats.nearPending],
      ['OFFSCREEN NOT LOADED (normal lazy)', d.stats.offNotLoaded],
      ['OFFSCREEN DECODED', d.stats.offDecoded],
      ['Scroll Y', Math.round(window.pageYOffset)],
      ['JS mode', document.documentElement.classList.contains('weelz-slideshow-js-ready') ? 'modern' : (document.documentElement.classList.contains('weelz-legacy-carousel') ? 'LEGACY fallback' : 'unknown/none')]
    ];

    var box = document.createElement('div');
    box.setAttribute('dir', 'ltr');
    box.style.cssText = 'position:fixed;inset:0;z-index:2147483647;overflow:auto;padding:12px;background:#0b0b0b;color:#eaeaea;font:11px/1.5 -apple-system,Menlo,monospace';

    var h = '<div style="font-size:15px;font-weight:700;margin-bottom:8px">WEELZ image report v4</div>';
    rows.forEach(function (row) {
      var v = String(row[1]);
      var warn = (row[0] === 'VISIBLE BLANK' || row[0] === 'REAL ERROR (retried)') && v !== '0';
      h += '<div style="display:flex;gap:6px;padding:3px 0;border-bottom:1px solid #222">' +
        '<span style="flex:0 0 52%;color:#9a9a9a">' + esc(row[0]) + '</span>' +
        '<span style="flex:1;word-break:break-all;color:' + (warn ? '#ff6b6b' : '#eaeaea') + '">' + esc(v) + '</span></div>';
    });

    h += '<div style="margin:12px 0 6px;font-weight:700;color:#ff6b6b">VISIBLE BLANK (' + d.blanks.length + ')</div>';
    if (!d.blanks.length) h += '<div style="color:#5ddf88">none - all on-screen images have pixels</div>';
    else d.blanks.slice(0, 10).forEach(function (b) {
      h += '<div style="padding:7px 0;border-bottom:1px solid #222;word-break:break-all">' + b + '</div>';
    });

    h += '<button id="wdc" style="margin:14px 0 60px;padding:12px 18px;border:1px solid #444;background:#1a1a1a;color:#fff;font:600 13px system-ui">Close</button>';
    box.innerHTML = h;
    document.body.appendChild(box);
    document.getElementById('wdc').addEventListener('click', function () { box.remove(); });
  }

  function addButton() {
    var b = document.createElement('button');
    b.textContent = 'IMG REPORT';
    b.style.cssText = 'position:fixed;z-index:2147483000;left:10px;bottom:120px;padding:12px 14px;border:0;border-radius:6px;background:#bd3028;color:#fff;font:700 12px system-ui;box-shadow:0 4px 14px rgba(0,0,0,.4)';
    b.addEventListener('click', show);
    document.body.appendChild(b);
  }

  if (document.readyState === 'complete') addButton();
  else window.addEventListener('load', addButton);
})();
